import { HStack, VStack } from '@sgme/ui';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import type { TileExecution } from '@/store/types.ts';

type ExecutionStatusProps = {
  status: TileExecution['status'];
};

export const ExecutionStatus = (props: ExecutionStatusProps) => {
  const { status } = props;

  return (
    <VStack
      flex="expand"
      horizontalAlignment="center"
      verticalAlignment="center"
      className="bg-lvl1 w-100 h-100 pb-16px"
    >
      <HStack
        horizontalAlignment="center"
        verticalAlignment="center"
        className={clsx('bg-opacity-10 rounded-circle mb-3', {
          'bg-warning': status === 'PENDING',
          'bg-success': status === 'SUCCESS',
          'bg-danger': status === 'REJECTED',
        })}
        style={{ width: 48, height: 48 }}
        data-e2e={`execution-status-${status}`}
      >
        <i
          className={clsx('icon icon-md line-height-1', {
            'text-warning': status === 'PENDING',
            'text-success': status === 'SUCCESS',
            'text-danger': status === 'REJECTED',
          })}
        >
          {ICON_BY_STATUS[status]}
        </i>
      </HStack>

      <h4
        className={clsx({
          'text-warning': status === 'PENDING',
          'text-success': status === 'SUCCESS',
          'text-danger': status === 'REJECTED',
        })}
        data-e2e="execution-status"
      >
        <FormattedMessage id={`tile.execution.status.${status}`} />
      </h4>

      <div className="text-secondary" data-e2e="execution-description">
        <FormattedMessage id={`tile.execution.status.description.${status}`} />
      </div>
    </VStack>
  );
};

const ICON_BY_STATUS = {
  PENDING: 'hourglass_empty',
  SUCCESS: 'check',
  REJECTED: 'warning',
};
